<template lang="pug">
	DxPieChart(
		:id="id",
		:data-source="dataSource",
		type="doughnut",
		:inner-radius="innerRadius",
		resolve-label-overlapping="shift",
		:size="size",
		:legend="{ visible: false }",
		center-template="centerTemplate",
		:palette="palette",
	)
		DxSeries(
			argument-field="name"
			value-field="value"
		)
			DxLabel(
				:visible="isLabel"
				:customize-text="customizeLabel"
				background-color="none"
				format="fixedPoint"
			)
				DxConnector(:visible="true")

		slot(name="tooltip")
			DxTooltip(
				:enabled="true"
				:customize-tooltip="(point) => ({ html: `${point.argument}: ${point.value}%` })"
			)

		template(v-slot:centerTemplate="center")
			svg
				text(
					text-anchor="middle",
					x="80",
					y="100",
				)
					tspan(
						:style="{ fontSize: 20, fontName: 'Roboto', fontWeight: 400, fill: '#1eb2f5' }",
						x="80",
						dy="20px",
					) {{ maxValue }}
</template>

<script>
	import {
		DxPieChart,
		DxSeries,
		DxExport,
		DxTooltip,
		DxLegend,
		DxLabel,
		DxConnector,
	} from 'devextreme-vue/pie-chart';
	import VueTypes from "vue-types";

	export default {
		translationCategory: 'logs.components.ChartDoughnut',
		name: "LogsChartDoughnut",
		props: {
			id: VueTypes.string.def(`chart-id-${(+new Date).toString(16)}`),
			dataSource: VueTypes.array.def([]),
			innerRadius: VueTypes.number.def(0.75),
			isLabel: VueTypes.bool.def(true),
			size: VueTypes.object.def({ width: 220, height: 200 }),
			palette: VueTypes.any.def('Soft Pastel'),
			maxValue: VueTypes.any.def(null),
		},
		components: {
			DxPieChart, DxSeries, DxExport, DxTooltip, DxLegend, DxLabel, DxConnector
		},
		methods: {
			customizeLabel({ argumentText, valueText }) {
				return `${argumentText}\n${valueText}%`;
			},
		}
	}
</script>

<style scoped>

</style>
